<template>
  <div class="interview-page-modal">
    <slot />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({})
</script>
<style lang="postcss">
.interview-page-modal {
  max-width: 90%;
  padding: 2rem;
  border: 1px solid #e8ecf6;
  background: #fff;
}
</style>
